import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/helpers/cn';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import clsx from 'clsx';
function Button({ children, disabled, icon, mode = 'interactive', variant = 'solid', className }) {
    const isClickable = mode === 'interactive';
    if (!children) {
        return null;
    }
    return children({
        className: cn(
        // Default
        'inline-flex items-center gap-x-0.5 outline-none transition-(colors,transform) duration-300 justify-center text-center', 
        // Typography
        (variant === 'solid' || variant === 'outline') && 'type-button-sm sm:type-button-lg', (variant === 'text' || variant === 'link') && 'type-body-small-book sm:type-body-regular-book text-left', variant === 'link' && 'underline', 
        // Size
        (variant === 'solid' || variant === 'outline') && 'px-0.75 py-0.5 sm:px-1 sm:py-0.75', 
        // Text color
        variant === 'solid' && 'light:text-text-contrast dark:text-text-primary', variant === 'outline' && 'light:text-text-primary dark:text-text-contrast', variant === 'text' && 'light:text-text-body dark:text-text-contrast', variant === 'link' && 'light:text-text-body dark:text-text-contrast', 
        // Background and border color
        variant === 'solid' && 'border', variant === 'solid' &&
            'light-a:border-surface-contrast light-a:bg-surface-contrast light-b:border-surface-expressive light-b:bg-surface-expressive dark:border-surface-primary dark:bg-surface-primary', variant === 'outline' &&
            'border light-a:border-border-primary light-b:border-border-expressive dark-b:border-border-expressive dark-a:border-border-contrast', 
        // Hover
        isClickable
            ? [
                variant === 'solid' &&
                    'light:hover:bg-surface-brand-hover light:hover:border-surface-brand-hover dark:hover:bg-surface-hover dark:hover:border-surface-hover dark:hover:text-text-contrast',
                variant === 'outline' &&
                    'light:hover:border-border-brand dark-a:hover:border-border-expressive dark-b:hover:border-border-contrast',
                variant === 'text' && 'light:hover:text-text-hover dark:hover:text-text-hover-contrast',
                variant === 'outline' && 'hover:border-border-brand',
                variant === 'text' && 'light:hover:text-text-hover dark:hover:text-text-hover-contrast hover:underline',
                variant === 'link' && 'light:hover:text-text-hover dark:hover:text-text-hover-contrast',
            ]
            : [
                variant === 'solid' &&
                    'light:group-hover/button:bg-surface-brand-hover light:group-hover/button:border-surface-brand-hover dark:group-hover/button:bg-surface-hover dark:group-hover/button:border-surface-hover dark:group-hover/button:text-text-contrast',
                variant === 'outline' &&
                    'light:group-hover/button:border-border-brand dark-a:group-hover/button:border-border-expressive dark-b:group-hover/button:border-border-contrast',
                variant === 'text' &&
                    'light:group-hover/button:text-text-hover dark:group-hover/button:text-text-hover-contrast group-hover/button:underline',
                variant === 'link' &&
                    'light:group-hover/button:text-text-hover dark:group-hover/button:text-text-hover-contrast',
            ], 
        // Focus
        isClickable && [
            variant === 'solid' && 'focus-visible:outline-solid focus-visible:outline-1 focus-visible:outline-offset-3',
            variant === 'solid' &&
                'light-a:focus-visible:outline-border-primary light-b:focus-visible:outline-border-expressive dark:focus-visible:outline-border-contrast',
            variant === 'outline' && 'focus-visible:outline-solid focus-visible:outline-1 focus-visible:outline-offset-3',
            variant === 'outline' &&
                'light-a:focus-visible:outline-border-primary light-b:focus-visible:outline-border-expressive dark-a:focus-visible:outline-border-contrast dark-b:focus-visible:outline-border-expressive',
            variant === 'text' && 'focus-visible:outline-dashed focus-visible:outline-1 focus-visible:outline-offset-3',
            variant === 'text' && 'light:focus-visible:outline-symbol-primary dark:focus-visible:outline-symbol-contrast',
            variant === 'link' && 'focus-visible:outline-dashed focus-visible:outline-1 focus-visible:outline-offset-3',
            variant === 'link' && 'light:focus-visible:outline-symbol-primary dark:focus-visible:outline-symbol-contrast',
        ], 
        //Disabled
        variant === 'solid' &&
            'disabled:border-surface-secondary disabled:bg-surface-secondary disabled:text-text-secondary', variant === 'outline' && ['disabled:border-border-muted disabled:text-text-secondary'], variant === 'text' && ['disabled:text-text-secondary'], disabled && [
            'pointer-events-none',
            variant === 'solid' && 'opacity-30',
            variant === 'outline' && 'opacity-30',
            variant === 'text' && 'opacity-40',
            variant === 'link' && 'opacity-40',
        ], className),
        icon: icon && (_jsx("span", { className: clsx('flex aspect-square w-[18px] items-center justify-center sm:max-w-1.25', (variant === 'text' || variant === 'link') &&
                'dark:bg-ui-specific-glass-light light:bg-ui-specific-glass-dark'), children: _jsx(ButtonIcon, { variant: icon }) })),
        inert: disabled ? '' : undefined,
        'aria-disabled': disabled,
    });
}
export default Button;
